export default __webpack_public_path__ + "static/media/synergy-one-logo-black.0644933b.svg";